










































import { Component, Vue} from 'vue-property-decorator';
import { CardForm } from '@/components/bwaff';
import BemobApi from '@/services/rest/bemob';
import IntercomMixin from '@/components/helpers/intercom-mixin';
import RegisterStep from '@/views/pages/components/register-step.vue';
import {mixins} from 'vue-class-component';

@Component({
  components: {
    CardForm,
    RegisterStep,
  }
})
export default class RegisterCurrency extends mixins<IntercomMixin>(IntercomMixin) {
  bemobApi: BemobApi = new BemobApi();
  showSuccessMsg:boolean = false;

  sendAgain(){
    this.$store.commit('loading', true);
    this.bemobApi.resendVerificationEmail().then(()=>{
      this.showSuccessMsg = true;
      this.$store.commit('loading', false);
    }).catch((err)=>{
      this.bus.emit('toast-error', err?.response?.status);
    })
  }
}
